import { render, staticRenderFns } from "./contlist.vue?vue&type=template&id=1c89d2d6&scoped=true&"
import script from "./contlist.vue?vue&type=script&lang=js&"
export * from "./contlist.vue?vue&type=script&lang=js&"
import style0 from "./contlist.vue?vue&type=style&index=0&id=1c89d2d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c89d2d6",
  null
  
)

export default component.exports